export const environment = {
  production: true,
  configUrl: 'assets/config/config.json',
};
